import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';

@Component({
    selector: 'app-new-tipo',
    templateUrl: './new-tipo.component.html',
    styleUrls: ['./new-tipo.component.css'],
    standalone: false
})
export class NewTipoComponent implements OnInit {

  form: UntypedFormGroup;
  nombre: string = "";

  constructor(private fb: UntypedFormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<NewTipoComponent>) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      nombre: [this.nombre, [Validators.required, Validators.minLength(1), Validators.maxLength(32)]],
    });
  }

  save() {
    const {value, valid} = this.form;
    if(valid){
      this.dialogRef.close(value);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
